import React, { FC } from 'react';

type DescriptionProps = {
  description: string;
  helpDocsLink: string;
  linkText: string;
};

const Description: FC<DescriptionProps> = ({ description, helpDocsLink, linkText }) => (
  <span>
    {`${description} `}
    <a target="_blank" rel="noopener noreferrer" href={helpDocsLink}>
      {linkText}
    </a>
    .
  </span>
);

export default Description;
